//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

// Set to 'off' in this browser's local storage to keep anything from opening
// itself on the user's behalf. For automated browsers, whose clicks a tour's
// overlay would otherwise intercept and whose idle stretches would otherwise
// start one. Read where the help moment is offered rather than by whoever
// takes it, so a surface added later is covered without being asked.
export const AUTO_TOURS_KEY = 'mc-auto-tours';

export const autoToursOff = (): boolean => {
  try {
    return localStorage.getItem(AUTO_TOURS_KEY) === 'off';
  } catch {
    return false;
  }
};
